import type { AppLocale } from "@metaadsmanager/tk-master-contracts";
import { useSyncExternalStore } from "react";

import {
  getLocaleSnapshot,
  localeStorageKey,
} from "./config";

const localeChangedEvent = "tk-master:locale-changed";

/** 同 tab 内语言切换后通知订阅者（storage 事件不覆盖同页写入）。 */
export function notifyLocaleChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(localeChangedEvent));
}

function subscribeClientLocale(onStoreChange: () => void): () => void {
  const handleLocaleEvent = () => onStoreChange();
  const handleStorage = (event: StorageEvent) => {
    if (event.key === localeStorageKey || event.key === null) {
      onStoreChange();
    }
  };
  window.addEventListener(localeChangedEvent, handleLocaleEvent);
  window.addEventListener("storage", handleStorage);
  return () => {
    window.removeEventListener(localeChangedEvent, handleLocaleEvent);
    window.removeEventListener("storage", handleStorage);
  };
}

/** 客户端 locale；getSnapshot / getServerSnapshot 共用 bootstrap `data-locale`。 */
export function useClientLocale(): AppLocale {
  return useSyncExternalStore(
    subscribeClientLocale,
    getLocaleSnapshot,
    getLocaleSnapshot,
  );
}
